import { SETTINGS_MEMORY_ROUTE_TAB_CONFIG } from './settings_modal_memory_tabs'
import {
  LEGACY_PERSONAL_EXACT_SEGMENTS,
  LEGACY_PERSONAL_PREFIX_SEGMENTS,
} from './settingsConfig'

const PERSONAL_BASE = '/app/personal'

/**
 * Tab slug for legacy personal redirects. Unlike {@link memoryPathnameToTabSlug}, section base
 * paths (e.g. `/app/personal/security`) return null so the modal can pick the first flag-enabled tab.
 *
 * @param {string} section — {@link SETTINGS_SECTION} value
 * @param {string} pathname
 * @returns {string | null}
 */
function legacyPersonalMemoryTabSlug(section, pathname) {
  const tabCfg = SETTINGS_MEMORY_ROUTE_TAB_CONFIG[section]
  if (tabCfg?.paths == null) {
    return null
  }
  const defaultFullPath = tabCfg.paths[tabCfg.defaultTab]
  if (defaultFullPath == null) {
    return null
  }
  const sectionBase = defaultFullPath.slice(0, defaultFullPath.lastIndexOf('/'))
  if (pathname !== sectionBase && !pathname.startsWith(`${sectionBase}/`)) {
    return null
  }
  const rest = pathname.slice(sectionBase.length).replace(/^\//, '')
  const firstSegment = rest.split('/').filter(Boolean)[0] ?? null
  if (firstSegment && tabCfg.paths[firstSegment]) {
    return firstSegment
  }
  return null
}

/**
 * When `ap_rebrand_settings_ia` is on, deep links to legacy personal routes redirect to the host
 * page + `?settings=…` (and optional `settings_tab=` for memory-routed tabs such as profile/security).
 *
 * @param {string} pathname — `location.pathname`
 * @returns {{ section: string, settingsTab: string | null } | null}
 */
export function matchLegacyPersonalPathToSettingsSection(pathname) {
  for (const [segment, section] of LEGACY_PERSONAL_PREFIX_SEGMENTS) {
    const base = `${PERSONAL_BASE}/${segment}`
    if (pathname === base || pathname.startsWith(`${base}/`)) {
      return {
        section,
        settingsTab: legacyPersonalMemoryTabSlug(section, pathname),
      }
    }
  }

  for (const [segment, section] of LEGACY_PERSONAL_EXACT_SEGMENTS) {
    const base = `${PERSONAL_BASE}/${segment}`
    if (pathname === base || pathname.startsWith(`${base}/`)) {
      return { section, settingsTab: null }
    }
  }

  return null
}
